import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useHistory } from 'react-router';
import './table.styles/styletable.css'
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
    root: {
        backgroundColor: 'white',
        fontFamily: "Montserrat",
        fontWeight: 600,
        marginTop: '23px',
        marginBottom: "100px",
        maxHeight: '500px',
      
    },

    header: {
      
        fontFamily: "Montserrat",
        border: '1px solid #D8D8D8',
        fontWeight: 600,
        minWidth: 110,
        fontSize: '14px',
        color: '#DC251A',
        textAlign: 'left',
        paddingTop: '9px',
        paddingBottom: '9px'
        
    

    },
    rowStyle: {
        fontWeight: '600',
        fontFamily: "Montserrat",
        fontSize: '14px',
        color: '#313132',
    },

    typography: {
        fontFamily: "Montserrat",
        fontSize: 12,
        fontWeight: 600,
    },
});




export default function TableDatabase(props) {
    const classes = useStyles();
    const history = useHistory();
    const handleClick = (record_id, event) => {
        history.push(`/tabpanel/${record_id}`, {place: event.place, eventType: event.eventType, eventDate: event.eventDate, eventDescription: event.eventDescription})      
    }

  
    return (

        <TableContainer className={classes.root}  >
            <Table className={classes.header} aria-label="simple table" >
                <TableHead >
                    <TableRow style={{height: 20}} >
                       
                        <TableCell  width={300} style={{backgroundColor: 'white', color: '#DC251A', fontSize: '14px'}}  className={classes.header}>
                            <span>EVENT NAME</span>
                        </TableCell>
                        <TableCell width={280} className={classes.header} style={{backgroundColor: 'white', color: '#DC251A', fontSize: '14px'}} align="left">
                            <span>EVENT DESCRIPTION</span>
                        </TableCell>
                        <TableCell width={170} className={classes.header} style={{backgroundColor: 'white', color: '#DC251A', fontSize: '14px'}} align="left">
                            <span> EVENT DATE </span>
                        </TableCell>
                        <TableCell  width={200} className={classes.header} style={{backgroundColor: 'white', color: '#DC251A', fontSize: '14px'}} align="left">
                            <span> EVENT TYPE</span>
                        </TableCell>
                        <TableCell  width={200} className={classes.header} style={{backgroundColor: 'white', color: '#DC251A', fontSize: '14px'}} align="left">
                            <span> PLACE</span>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.event && props.event.length ? props.event.map((event, index) => (
                        <TableRow  key={index} style={index % 2 ? { background: "#F2F2F2", cursor: 'pointer' } : { background: "white", cursor: 'pointer'}}   >
                        
                            <TableCell  style={{borderLeft:  '1px solid white', borderBottom: '1px solid white'}} className={classes.rowStyle} align="left" onClick={() => handleClick(event.id, event)}>{event.place}'s {event.eventType}</TableCell>
                            <TableCell style={{ borderBottom: '1px solid white'}} className={classes.rowStyle} align="left" onClick={() => handleClick(event.id, event)}>{event.eventDescription}</TableCell>
                            <TableCell style={{ borderBottom: '1px solid white'}} className={classes.rowStyle} align="left" onClick={() => handleClick(event.id, event)}>{event.eventDate}</TableCell>
                            <TableCell style={{ borderBottom: '1px solid white'}} className={classes.rowStyle} align="left" onClick={() => handleClick(event.id, event)}>{event.eventType}</TableCell>
                            <TableCell style={{borderRight:  '1px solid white', borderBottom: '1px solid white'}} className={classes.rowStyle} align="left" onClick={() => handleClick(event.id, event)}>{event.place}</TableCell>
                        </TableRow>
                    )) : null}
                </TableBody>
            </Table>
        </TableContainer>
    );
}